<template lang="pug">
    div
        v-dialog.fixedDialog(
            v-model="showMood"
            persistent
            no-click-animation
        )
            // Mood capture
            mood-component(v-if="showMood" @close="closeMood")
</template>

<script>
    import NewMood from '~components/NewMood';
    import VueTypes from 'vue-types';
    import { mapActions } from 'vuex';
    import { mapFields } from 'vuex-map-fields';

    export default {
        components: {
            MoodComponent: NewMood
        },
        props: {
            id: VueTypes.string.def('')
        },
        data() {
            return {
                showMood: false
            };
        },
        async created() {
            if (!this.session?.id)
                await this.read({ id: this.id, isMeeting: true });
            this.showMood = true;
        },
        computed: {
            ...mapFields('sessions', ['session'])
        },
        beforeDestroy() {
            this.resetSession();
        },
        methods: {
            ...mapActions('sessions', ['resetSession', 'setShowMood', 'read']),

            closeMood() {
                this.setShowMood();
            },
            navigateToThemes() {
                this.$router.push({ name: 'dashboard.themes' });
            }
        }
    };
</script>

<style lang="stylus">
    .title
        margin-bottom: 15px
</style>
